import React, { FunctionComponent, useState } from 'react'
import {
  Image,
  RichText,
  DateField,
  Text,
  Link
} from '@sitecore-jss/sitecore-jss-react'
import { ContentHubSpecialOffersSlideModel } from './models/fields.model'
import ModalDialog from '../../react-only-components/ModalDialog/ModalDialog'

const CarouselSlide: FunctionComponent<{
  model: ContentHubSpecialOffersSlideModel
  isEE: boolean
}> = ({ model, isEE }) => {
  const [modalIsOpen, setIsOpen] = useState(false)
  const options = { year: 'numeric', month: 'long', day: 'numeric' } as const

  const openModal = () => {
    setIsOpen(true)
  }

  const closeModal = () => {
    setIsOpen(false)
  }

  return (
    <>
      {model.disclaimer && (
        <ModalDialog isOpen={modalIsOpen} close={closeModal}>
          **{model.disclaimer}
        </ModalDialog>
      )}
      {model.badge ? (
        <div className="card-label">
          <Text field={{ value: model.badge }} tag="p" />
        </div>
      ) : null}
      <div
        className={`special-offers-card special-offers-card--${
          model.type?.value === 'offerCardWide' ? 'large' : 'small'
        }`}
      >
        <pfe-card
          pfe-color="lightest"
          class="card-with-header-image slide-card slide-card--strech"
        >
          <Image
            loading="lazy"
            slot="pfe-card--header"
            pfe-overflow="top right left"
            className="slide-card__image"
            field={model.image}
          />
          <div className="special-offers-card__title">
            <span>
              <RichText
                tag="div"
                slot="pfe-card--header"
                field={model.discount}
                className="slide-card__text slide-card__text--title slide-card__text--overflow-unset"
              />
              <RichText
                tag="div"
                field={model.title}
                className="slide-card__text slide-card__text--inline slide-card__text--overflow-unset"
              />
            </span>
          </div>
          {model.disclaimer && (
            <RichText
              onClick={openModal}
              field={{ value: 'Disclaimer' }}
              className="special-offers-card__text"
            />
          )}
          <div className="slide-card__text slide-card__text--strech">
            <RichText tag="div" field={model.expirationLabel} /> :&nbsp;
            <DateField
              field={model.expiration}
              tag="p"
              render={(date) => date?.toLocaleDateString('en-GB', options)}
            />
          </div>
          {(isEE ||
            model.buttonPrimary?.value?.href ||
            model.buttonPrimary?.value?.title) && (
            <pfe-cta slot="pfe-card--footer" pfe-priority="primary">
              <Link field={model.buttonPrimary}>
                {model.buttonPrimary?.value?.title}
              </Link>
            </pfe-cta>
          )}
          {model.type?.value === 'offerCardWide' &&
            (isEE ||
              model.buttonSecondary?.value?.href ||
              model.buttonSecondary?.value?.title) && (
              <pfe-cta slot="pfe-card--footer" pfe-priority="secondary">
                <Link field={model.buttonSecondary}>
                  {model.buttonSecondary?.value?.title}
                </Link>
              </pfe-cta>
            )}
        </pfe-card>
      </div>
    </>
  )
}

export default CarouselSlide
